import axios from "axios"

// Get base URL
const getBaseURL = () => {
  switch (process.env.REACT_APP_STATUS) {
    case "DEV":
      return process.env.REACT_APP_DEV_URL
    case "STAGE":
      return process.env.REACT_APP_STAGE_URL
    case "PROD":
      return process.env.REACT_APP_PROD_URL
    default:
      return process.env.REACT_APP_PROD_URL
  }
}

// Get all email report configurations
export const getAllEmailReportConfigs = async () => {
  const response = await axios.get(
    `${getBaseURL()}/admin/v1/email-reports/configs`
  )
  return response.data
}

// Get email report config for specific company
export const getEmailReportConfig = async (companyId) => {
  const response = await axios.get(
    `${getBaseURL()}/admin/v1/email-reports/config/${companyId}`
  )
  return response.data
}

// Create email report configuration
export const createEmailReportConfig = async (data) => {
  const response = await axios.post(
    `${getBaseURL()}/admin/v1/email-reports/config`,
    data
  )
  return response.data
}

// Update email report configuration
export const updateEmailReportConfig = async (companyId, data) => {
  const response = await axios.put(
    `${getBaseURL()}/admin/v1/email-reports/config/${companyId}`,
    data
  )
  return response.data
}

// Delete email report configuration
export const deleteEmailReportConfig = async (companyId) => {
  const response = await axios.delete(
    `${getBaseURL()}/admin/v1/email-reports/config/${companyId}`
  )
  return response.data
}

// Resend report now (manual trigger)
export const resendEmailReport = async (companyId) => {
  const response = await axios.post(
    `${getBaseURL()}/admin/v1/email-reports/resend/${companyId}`,
    {}
  )
  return response.data
}

// Send test email
export const testEmailReport = async (companyId, testEmail) => {
  const response = await axios.post(
    `${getBaseURL()}/admin/v1/email-reports/test`,
    { company_id: companyId, test_email: testEmail }
  )
  return response.data
}
